import React, { useEffect, useState } from 'react'
import { useApiStore } from '../../hooks/ApiStoreContext';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-bs5';
import 'datatables.net-responsive-dt';
import { Card, CardBody, CardHeader, Col, Row } from 'react-bootstrap';
import Moment from 'react-moment';

function GetInTouch() {

    const apiStore = useApiStore();
  DataTable.use(DT);
  //const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    getInTouchList();
    }, []);
  
    const getInTouchList = async () => {
      try {
        const response = await apiStore.get("/contact");
        setTableData(response);
      } catch (error) {
        if (error.response.status !== 401) {
          console.error("There was an error fetching contact details!", error);
        }
      }
    };

    return (
    <Row>
      <Col md={12}>
        <Card className="mb-4">
          <CardHeader className="pb-0">
            <Row>
              <Col md={12}>
                <h4>Get in Touch List</h4>
              </Col>
              
            </Row>
          </CardHeader>
          <CardBody className="px-0 pt-0 pb-2">
            <div className="mx-3">
              <DataTable
                className="display table align-items-center mb-0 p-0"
                data={tableData}
                options={{
                  responsive: true,
                  columns: [
                    { data: "name", className: "text-secondary text-sm font-weight-bold align-middle" },
                    { data: "email", className: "text-secondary text-sm font-weight-bold align-middle" },
                    { data: "message", className: "text-secondary text-sm font-weight-bold align-middle" },                    
                    { data: "createdDate", className: "text-secondary text-sm font-weight-bold align-middle", },                    
                  ],
                }}
                slots={{
                    3: (data, row) => {
                                        return (
                                          <React.Fragment>                                            
                                            <Moment format='DD-MM-yyyy hh:mm A'>{data}</Moment>
                                          </React.Fragment>
                                        );
                                      },
                }}>
                <thead>
                  <tr>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Name</th>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Email</th>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Message</th>
                    <th className="text-uppercase text-secondary text-sm font-weight-bolder">Created Date</th>
                  </tr>
                </thead>
              </DataTable>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}

export default GetInTouch